import styles from './index.scss'
import { useState } from 'react'
import classnames from 'classnames'
import Province from './component/province'

type PropsType = {
  value?: any
  onChange?: any
  disabled?: Boolean
}

const AreaNumber = (props: PropsType) => {
  const [visible, updateVisible] = useState(false)
  return (
    <>
      <div
        className={
          classnames([styles['car-number-area'], { [styles['car-number-area--disabled']]: props?.disabled } ])
        }
        onClick={() => updateVisible(true)}
      >
        {props?.value || <span className={styles['car-number-area-placeholder']}>{'请选择'}</span>}
      </div>
      {
        visible && <Province
          value={props?.value?.split("")}
          visible={visible}
          updateVisible={updateVisible}
          onChange={v => {
            props?.onChange?.(v)
            updateVisible?.(false)
          }}
        />
      }
    </>
  )
}

export default AreaNumber
